// FullListComponent.jsx
import React, { useMemo, useState } from 'react';
import closeIco from "../../../assets/icons/close_modal.svg";
import pinIco from "../../../assets/icons/interface/mapPin.svg";
import clockIco from "../../../assets/icons/interface/clock.svg";

// Иконки категорий
import beachesIco from '../../../assets/icons/interface/beaches.svg';
import hotelIco from '../../../assets/icons/interface/hotel.svg';
import entertainmentIco from '../../../assets/icons/interface/entertainment.svg';
import bankCategoryIco from '../../../assets/icons/interface/bank.svg';
import societyIco from '../../../assets/icons/interface/society.svg';
import barIco from '../../../assets/icons/interface/bar.svg';
import fastfoodIco from '../../../assets/icons/interface/fastfood.svg';
import restaurantIco from '../../../assets/icons/interface/restaurant.svg';
import shopIco from '../../../assets/icons/interface/shop.svg';
import educationIco from '../../../assets/icons/interface/education.svg';
import estateIco from '../../../assets/icons/interface/estate.svg';
import otherIco from '../../../assets/icons/interface/other.svg';

const categoryNames = {
    beaches: "Beach Clubs",
    hotel: "Hotels",
    entertainment: "Entertaiments",
    bank: "Banks & ATM",
    society: "Society & Services",
    sport: "Sport, Health, Beauty",
    food: "Restaurants",
    // bar: "Бары",
    // fastfood: "Фастфуд",
    // restaurant: "Рестораны",
    shop: "Shops",
    education: "Education",
    estate: "Real Estate",
    other: "Addition",
};

const categoryIcons = {
    beaches: beachesIco,
    hotel: hotelIco,
    entertainment: entertainmentIco,
    bank: bankCategoryIco,
    society: societyIco,
    bar: barIco,
    fastfood: fastfoodIco,
    restaurant: restaurantIco,
    shop: shopIco,
    education: educationIco,
    estate: estateIco,
    other: otherIco,
};

const categoryColors = {
    beaches:   '#f8bc7e',
    hotel:     '#de877b',
    entertainment: '#423086',
    bank:      '#004e8d',
    society:   '#004e8d',
    bar:       '#4baf53',
    fastfood:  '#ffcf00',
    restaurant:'#ffcf00',
    shop:      '#5299d3',
    education: '#5299d3',
    estate:    '#fff',
    other:     '#edeeee',
};

const FullListComponent = ({
                               onClose,
                               roadsData,
                               setSelectedMarker,
                               userPosition
                           }) => {
    // единственная открытая группа (catKey) или null
    const [openGroup, setOpenGroup] = useState(null);
    const toggleGroup = catKey =>
        setOpenGroup(prev => (prev === catKey ? null : catKey));

    // фильтрация → группировка → сортировка
    const grouped = useMemo(() => {
        if (!roadsData?.features) return {};

        const points = roadsData.features.filter(feature => {
            if (feature.geometry.type !== 'Point') return false;

            const props = feature.properties || {};
            // исключаем категории “панорама”
            const cat = (props.category || '').toLowerCase().trim();
            if (cat.includes('panorama') || cat.includes('панорама')) return false;

            // пустые имена или содержащие "(1)"
            const name = (props.name || '').trim();
            if (!name || name.includes('(1)')) return false;

            return true;
        });

        const groups = points.reduce((acc, feature) => {
            const props = feature.properties;
            const key = (props.category || 'other').toLowerCase();
            if (!acc[key]) acc[key] = [];
            acc[key].push({ ...props, coords: feature.geometry.coordinates });
            return acc;
        }, {});

        // сортируем внутри каждой группы по name
        Object.values(groups).forEach(arr =>
            arr.sort((a, b) =>
                a.name.localeCompare(b.name, 'ru', { sensitivity: 'base' })
            )
        );

        return groups;
    }, [roadsData]);

    // проверка, открыто ли сейчас
    const isOpenNow = ({ start, end }) => {
        if (!start || !end) return true;
        const [h1, m1] = start.split(':').map(Number);
        const [h2, m2] = end.split(':').map(Number);
        const now = new Date();
        const minutes = now.getHours() * 60 + now.getMinutes();
        return minutes >= h1 * 60 + m1 && minutes <= h2 * 60 + m2;
    };

    return (
        <div className="container full-list">
            <div className="container__header">
                <h1>Все заведения</h1>
            </div>

            <div className="container__body">
                {Object.entries(categoryNames).map(([catKey, catLabel]) => {
                    const items = grouped[catKey];
                    if (!items?.length) return null;
                    const isExpanded = openGroup === catKey;

                    return (
                        <section key={catKey} className="category-group">
                            <h2
                                className={`category-group__header ${isExpanded ? 'expanded' : 'collapsed'}`}
                                style={{
                                    background: categoryColors[catKey],
                                    cursor: 'pointer'
                                }}
                                onClick={() => toggleGroup(catKey)}
                            >
                                <img
                                    src={categoryIcons[catKey]}
                                    alt={catLabel}
                                    className="category-group__icon"
                                />
                                {catLabel}
                            </h2>

                            {isExpanded && (
                                <ul className="category-group__list">
                                    {items.map((item, idx) => {
                                        const openClass = isOpenNow(item.operatingHours) ? '' : 'closed';
                                        const time =
                                            item.operatingHours?.start && item.operatingHours?.end
                                                ? `${item.operatingHours.start}-${item.operatingHours.end}`
                                                : 'Уточняется';

                                        const logoPath = item.markerIconName
                                            ? `/icons/round_logo/${item.markerIconName}.png`
                                            : null;

                                        return (
                                            <li
                                                key={idx}
                                                className="category-item"
                                                onClick={() => {
                                                    const feat = roadsData.features.find(f =>
                                                        f.properties.name === item.name &&
                                                        Array.isArray(f.geometry.coordinates) &&
                                                        f.geometry.coordinates[0] === item.coords[0] &&
                                                        f.geometry.coordinates[1] === item.coords[1]
                                                    );
                                                    if (feat) {
                                                        setSelectedMarker(feat);
                                                        onClose();
                                                    }
                                                }}
                                            >
                                                {/*{logoPath && (*/}
                                                {/*    <div className="category-item__logo-container">*/}
                                                {/*        <img*/}
                                                {/*            src={logoPath}*/}
                                                {/*            alt={`${item.name} логотип`}*/}
                                                {/*            onError={e => (e.currentTarget.style.display = 'none')}*/}
                                                {/*        />*/}
                                                {/*    </div>*/}
                                                {/*)}*/}

                                                <div className="category-item__info">
                                                    <h3>{item.name}</h3>
                                                    <div
                                                        className="category-item__details"
                                                        style={{background: categoryColors[catKey]}}
                                                    >
                            {/*<span className={`time ${openClass}`}>*/}
                            {/*  <img src={clockIco} alt="Часы"/>*/}
                            {/*    {time}*/}
                            {/*</span>*/}
                                                    </div>
                                                </div>
                                            </li>
                                        );
                                    })}
                                </ul>
                            )}
                        </section>
                    );
                })}
            </div>
        </div>
    );
};

export default FullListComponent;
